<app-load-spinner></app-load-spinner>
<app-alert></app-alert>
<app-header></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>
